import React from 'react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
import { volumes } from '../data/content';
export function Volumes() {
  return <section className="border-b border-line bg-ink px-4 py-14 sm:px-6 sm:py-20" data-id="element-245" data-mp="183vj0iytunse">
      <SectionHeading eyebrow="Le contenu" title="Que contient Route Maladie Rénale™ ?" subtitle="Un système complet qui vous accompagne dès la première créatinine anormale jusqu’au suivi du patient atteint d’une maladie rénale." data-id="element-246" data-mp="181skfajlzmc2" />

      <ol className="mx-auto mt-10 grid w-full max-w-5xl grid-cols-1 gap-4 lg:grid-cols-2" data-id="element-247" data-mp="24surnz3bprl4">
        {volumes.map(volume => <li key={volume.title} className="flex flex-col rounded-2xl border border-line bg-surface p-5 sm:p-6" data-id="element-248" data-mp="1qwha6pyshq6n">
            <div className="flex items-center gap-3" data-id="element-249" data-mp="feyc1c02gdey">
              <span className="text-2xl" aria-hidden="true" data-id="element-250" data-mp="fhastlu38hqf">
                {volume.emoji}
              </span>
              <span className="rounded-full bg-lime/12 px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.16em] text-lime" data-id="element-251" data-mp="3o86msd8c7u94">
                {volume.number}
              </span>
            </div>
            <h3 className="mt-4 font-display text-xl font-extrabold leading-snug text-white sm:text-2xl" data-id="element-252" data-mp="20ymhpc9ydjy">
              {volume.title}
            </h3>
            <p className="mt-2 text-[14px] font-semibold leading-relaxed text-lime" data-id="element-253" data-mp="3t6gkovlg58yf">{volume.lead}</p>
            <p className="mt-3 text-[14px] leading-relaxed text-slate-400" data-id="element-254" data-mp="b0bvyi0ef24o">{volume.body}</p>
          </li>)}
      </ol>

      <div className="mx-auto mt-10 max-w-xl" data-id="element-255" data-mp="60h5ugog6gko">
        <CTAButton label="Je veux les 6 volumes complets" caption="6 volumes premium + 5 bonus • Téléchargement immédiat" data-id="element-256" data-mp="krprkep8bhsj" />
      </div>
    </section>;
}